import type { BatchJobKindView } from "../../batch_job_kind_contract";
import { PubmedIngestPanel } from "./PubmedIngestPanel";

export { PubmedIngestParamsForm } from "./PubmedIngestParamsForm";
export { usePubmedIngestParams } from "./usePubmedIngestParams";
export type { UsePubmedIngestParamsResult } from "./usePubmedIngestParams";

export const PUBMED_INGEST_VIEW: BatchJobKindView = {
  label: "PubMed query ingest",
  Panel: PubmedIngestPanel,
};
